import { AuthGuard } from '../app.authGuard';
import { MyTaskDetailComponent } from './myTaskDetail/myTaskDetail.component';
import { MyTaskListComponent } from './myTaskList/myTaskList.component';
import { Route } from "@angular/router";

export var MyTaskRouterModule: Route =       {
  path: 'mytask', children: [
    { path: 'detail', component: MyTaskDetailComponent, canActivate: [AuthGuard] },
    { path: 'list', component: MyTaskListComponent, canActivate: [AuthGuard] },
    { path: '', redirectTo: 'list', pathMatch: 'full', canActivate: [AuthGuard] },
    { path: '**', redirectTo: 'list', canActivate: [AuthGuard] }
  ]
}